<p-drawer
  [visible]="display"
  position="right"
  appendTo="body"
  header="Addresses Information"
  (onHide)="onHide()">
  <div class="mb-2 left-sidebar clientdetails">
    <!-- <h1 class="mb-3">Address Information</h1> -->
    <div class="clientdetails-section mb-4">
      <div class="scroll-box-hgt-drawer">
        <li
          class="p-2 mb-2 add-col d-flex"
          *ngFor="let item of clientAddressInformation; let i = index">
          <div class="icon">
            <i class="icon-Protection-days"></i>
          </div>
          <div class="ms-2 flex-grow-1">
            <div class="d-flex align-items-center">
              <div class="col-2"><i class="pi pi-map-marker"></i></div>
              <div class="col-10">
                <div class="row align-items-right">
                  <div class="col-12 onHidejustify-content-end d-flex">
                    <div class="text d-flex align-items-right">
                      <i
                        title="Delete"
                        class="icon-Delete me-1"
                        (click)="deleteCustomerAddress(item)">
                      </i>
                    </div>
                  </div>
                </div>

                <div
                  class="d-flex align-items-center justify-content-between mb-1">
                  <h3 class="mb-0 me-1" *ngIf="item.purposeD365 === '1'">
                    Business
                  </h3>
                  <h3 class="mb-0 me-1" *ngIf="item.purposeD365 === '2'">
                    Invoice
                  </h3>
                  <h3 class="mb-0 me-1" *ngIf="item.purposeD365 === '3'">
                    Payment
                  </h3>
                  <h3 class="mb-0 me-1" *ngIf="item.purposeD365 === '4'">
                    Delivery
                  </h3>
                  <h3 class="mb-0 me-1" *ngIf="item.purposeD365 === '5'">
                    Other
                  </h3>
                  <span
                    class="badge bg-primary me-auto"
                    *ngIf="item.isPrimaryD365 === 'Yes'"
                    >Primary</span
                  >
                  <span
                    *ngIf="!(item.isPrimaryD365 === 'Yes')"
                    class="tag ml-auto"
                    >{{ extractRoles(item.rolesD365) }}</span
                  >
                  <!-- <span class="tag ml-auto" *ngIf="i === 1">Business Delivery</span>
            <span class="tag ml-auto" *ngIf="i === 2">Delivery</span> -->
                </div>
                <div class="d-flex">
                  <i class="icon-address me-1"></i>
                  <address class="address mb-0">
                    <span (click)="openEditAddress(item)">
                      {{
                        item.streetD365 +
                          item.streetNumberD365 +
                          item.cityD365 +
                          ", " +
                          item.stateD365 +
                          ", " +
                          item.zipCodeD365
                      }}
                    </span>
                  </address>
                </div>
              </div>
            </div>
          </div>
        </li>
      </div>
    </div>
  </div>
</p-drawer>
